import React from 'react';
import Button from '@material-ui/core/Button';
import './AdminNewAccount.styl';

export default class AdminNewAccount extends React.PureComponent {
  render() {
    return (
      <div className="admin-new-account">
        <div className="text-content">
          <h3>Welcome to Your Coach Dashboard!</h3>
          <p>
            We’re excited for you to leverage conversation intelligence to close your reps’ skill
            gaps and improve overall team performance. It looks like your team is new to the
            platform, so there’s nothing to show at the moment. When the dashboard does begin
            populating, you’ll see analytics on call volume and conversation quality, as well as
            coaching activity across your managers’ teams and its impact on rep performance.
          </p>
          <p>While you wait, why not school up on getting the most from Coach?</p>
          <p>
            Check out our Help Center to learn more about what’s included in your dashboard, how to
            set up a Smart Alert, and how to quickly coach a call. You can also check out exclusive
            customer webinars where you’ll hear how your peers at other companies are using the
            platform.
          </p>
          <a
            href="https://support.mediafly.com/hc/en-us/sections/14407549154715-Coach-Dashboards"
            target="_blank"
            rel="noreferrer">
            <Button variant="contained" color="primary" className="ev-button">
              Check it Out
            </Button>
          </a>
        </div>
      </div>
    );
  }
}
